module.exports = __webpack_public_path__ + "static/img/a070.b05e467.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a070.jpg
// module id = SexX
// module chunks = 0